<ion-header translucent>
	<ion-toolbar>
		<ion-title> {{ 'absoluteTipInput.title' | translate }}</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" fill="clear">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<ion-row class="ion-justify-content-center ion-align-items-center" style="height: 100%">
		<ion-col size="12" size-lg="6" size-md="8">
			<ion-input
				(ionInput)="onInput($event)"
				[placeholder]="'absoluteTipInput.placeholder' | translate"
				[value]="text"
				class="tip-input"
				type="tel"
			/>
		</ion-col>
	</ion-row>
</ion-content>
<ion-footer class="ion-padding">
	<ion-button (click)="confirm()" class="pay-btn" expand="block">{{ 'common.confirm' | translate }}</ion-button>
</ion-footer>
